if (!customElements.get('variant-label')) {
  class VariantLabel extends HTMLElement {
    constructor() {
      super();
      this.variantLabels = this.querySelectorAll('.js-variant-label');

      // Init direkte – ingen lazy loading
      const variantPicker = this.closest('.product')?.querySelector('variant-picker');
      if (variantPicker) {
        variantPicker.addEventListener('on:variant:change', this.handleVariantChange.bind(this));
      }

      if (this.dataset.currentVariantId) {
        this.setVisibleVariantLabel(this.dataset.currentVariantId);
      }
    }

    setVisibleVariantLabel(variantId) {
      this.variantLabels.forEach((label) => {
        const isActive = label.dataset.variantId === variantId.toString();
        label.classList.toggle('hidden', !isActive);
      });
    }

    handleVariantChange(evt) {
      if (evt.detail?.variant?.id) {
        this.setVisibleVariantLabel(evt.detail.variant.id);
      }
    }
  }

  customElements.define('variant-label', VariantLabel);
}
